import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
import { Typography } from '@material-ui/core';
const ExternalLink = ({ text, href }) => {
    return (
        <a href={href} target="_blank" rel="noreferrer" className={styles.link}>
            {text}
        </a>
    );
};

ExternalLink.propTypes = {
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
};

export const AgreeLabel = () => {
    return (
        <Typography component={'p'} className={styles.label}>
            I agree to <ExternalLink text="Authenticating.com" href={'https://authenticate.com/'} />
            's <ExternalLink
                text="Terms of Use"
                href="https://authenticating.com/terms-of-use"
            />{' '}
            and{' '}
            <ExternalLink text="Privacy Policy" href="https://authenticating.com/privacy-policy" />.
        </Typography>
    );
};

export const AuthorizationLabel = () => {
    return (
        <Typography component={'span'} className={styles.label}>
            I authorize <ExternalLink text="Authenticating.com" href="https://authenticate.com/" />{' '}
            to email a one-time passcode and verification results, and to send a tokenized link via
            SMS to the phone number provided for this verification request.
        </Typography>
    );
};
